import type { CameraViewport } from './camera-plan';

/** Reference frame for tracking distance, independent of output overlays. */
export const TRACKING_REFERENCE_VIEWPORT: CameraViewport = {
  width: 1920,
  height: 1080,
  padding: { top: 118, bottom: 230, left: 58, right: 58 },
};

/** Preserve geographic scale along the shorter frame edge at every output size. */
export function trackingViewportZoomOffset(viewport: CameraViewport): number {
  return Math.log2(Math.min(viewport.width, viewport.height) / TRACKING_REFERENCE_VIEWPORT.height);
}
